module.exports = __webpack_public_path__ + "assets/img/index-intro-02@2x.a93831a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/index-intro-02@2x.png
// module id = 903
// module chunks = 1